module.exports = __webpack_public_path__ + "img/Group1.2d9b26d5.svg";